import React, { Component, Fragment } from "react";
import { observer } from "mobx-react";
import { Form, Drawer, Button, Input, InputNumber, Select } from "antd";
import { languages, findLanguageByShortCode } from "common/languages";

const FormItem = Form.Item;

const { TextArea } = Input;
const Option = Select.Option;

const minArticle = 1;
const maxArticle = 200;
const minSection = 2;
const maxSection = 10;

@Form.create({})
@observer
export default class OpenAIDrawer extends Component {
	constructor(props) {
		super(props);
	}

	downloadArticle = () => {
		this.props.form.validateFieldsAndScroll((err, vals) => {
			if (err != null) {
				return;
			}

			let lang = findLanguageByShortCode(vals.language);

			this.props.generateArticles({
				articleSource: "OpenAI",
				contentGroupId: this.props.contentGroupId,
				inputInfo: JSON.stringify({
					topic: vals.topic,
					keywords: vals.keywords,
					nArticles: vals.nArticles,
					nSections: vals.nSections,
					language: lang.label,
				})
			});

			this.props.form.resetFields();
		});
	};

	hideDrawer = () => {
		this.props.form.resetFields();
		this.props.hideDrawer();
	};

	render() {
		const {
			ui: { openAIDrawerVisible, downloadingOpenAIArticles }
		} = this.props;



		return (
			<Drawer
				title="Generate OpenAI Articles"
				placement="top"
				closable={false}
				onClose={this.props.hideDrawer}
				visible={openAIDrawerVisible}
				height={700}
			>
				<Form>
					<FormItem label="Topic" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator("topic", {
							rules: [
								{
									required: true,
									message: "You need to enter a topic"
								}
							]
						})(
							<Input type="text" />
						)}
					</FormItem>
					<FormItem label="Keywords" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator("keywords", {
							rules: [
								{
									required: true,
									message: "You need to enter keywords"
								}
							]
						})(
							<TextArea type="text" rows={4} />
						)}
					</FormItem>

					<FormItem label="Number of Articles" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator("nArticles", {
							rules: [
								{
									required: true,
									type: "integer",
									min: minArticle,
									max: maxArticle,
									message:
										`Number of articles must be between ${minArticle} and ${maxArticle}`
								}
							]
						})(<InputNumber />)}
					</FormItem>
					<FormItem label="Number of Sections" style={{ marginBottom: 10 }}
						help="Number of sections in each article. The more sections, the longer the article will be."
					>
						{this.props.form.getFieldDecorator("nSections", {
							initialValue: 3,
							rules: [
								{
									required: true,
									type: "integer",
									min: minSection,
									max: maxSection,
									message:
										`Number of sections must be between ${minSection} and ${maxSection}`
								}
							]
						})(<InputNumber />)}
					</FormItem>
					<Form.Item
						label="Language"
						// {...formItemLayout}
						help="Select the language of your articles"
					>
						{this.props.form.getFieldDecorator(
							"language",
							{
								rules: [
									{
										required: true,
										message:
											"Please select a language"
									}
								]
							}
						)(
							<Select
								style={{ width: 200 }}
								placeholder="Select a language"
								notFoundContent="Select a language"
								showSearch={true}
								optionFilterProp="children"
								filterOption={(input, option) =>
									option.props.children
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
								}
							>
								{languages.map(item => {
									return (
										<Option
											value={item.value}
											key={item.value}
										>
											{item.label}
										</Option>
									);
								})}
							</Select>
						)}
					</Form.Item>
					<div
						style={{
							position: "absolute",
							bottom: 0,
							width: "100%",
							borderTop: "1px solid #e8e8e8",
							padding: "10px 16px",
							textAlign: "left",
							left: 0,
							background: "#fff",
							borderRadius: "0 0 4px 4px"
						}}
					>
						<Button
							style={{
								marginRight: 8
							}}
							onClick={this.props.hideDrawer}
						>
							Cancel
						</Button>
						<Button
							type="primary"
							onClick={this.downloadArticle}
							loading={downloadingOpenAIArticles}
						>
							Generate
						</Button>
					</div>
				</Form>
			</Drawer>
		);
	}
}
